// extracted by mini-css-extract-plugin
export default {"cls1":"jwLyTxFEt5KBsWSQ1CJc","cls2":"JWCMGgG_Iy7UB2vKHs6G jwLyTxFEt5KBsWSQ1CJc"};